const Styles = {

}

export default Styles;